import { IRoute } from "shared/interface/types";
import { leadRoutes } from "./leadRoute";
import { rolesAndPermissionRoutes } from "./rolesAndPermissionRoute";
import { teamManagementRoutes } from "./teamManagementRoute";
import { partnerUserRoutes } from "./partnerUser";

export const userManagementRoutes: IRoute[] = [...leadRoutes, ...rolesAndPermissionRoutes, ...teamManagementRoutes, ...partnerUserRoutes];
